<template lang="pug">
.s_app_box
  .app_header
    img.app_img(:src='mondoHeaderImg')
    .log_box
      img.app_log(src='./img/MondoMenu-logo.png')
  .app_from_box
    .app_from_title {{ headerTitle }}
    .app_from_text
      .checked_icons
        mu-icon(value='check_circle', v-for='item in 4', :key='item')
      .checked_text
        .line(v-for='item in headerText', :key='item') {{ item }}

    py-form.form(ref='form', :model='formLabelAlign', :rules='formRuleValidate')
      py-form-item(prop='firstName')
        landing-input(
          v-model='formLabelAlign.firstName',
          :label='"Full name*"'
        )
      py-form-item(prop='email')
        landing-input(v-model='formLabelAlign.email', :label='"Email*"')
      py-form-item(prop='mobile')
        landing-input(
          v-model='formLabelAlign.mobile',
          :label='"Mobile number"'
        )
      py-form-item(prop='jobTitle')
        landing-input(v-model='formLabelAlign.jobTitle', :label='"Job title*"')
      //- py-form-item(prop='address')
      //-   address-input(
      //-     :value="userInfo.userAddress"
      //-     :label="'Venue location'"
      //-     :address.sync="userInfo.userAddress"
      //-     :oldRawAddress.sync="oldUserInfo.rawAddress"
      //-     :oldAddress.sync="oldUserInfo.address"
      //-     :oldPostcode.sync="oldUserInfo.postcode"
      //-     :postcode.sync="userPostcode"
      //-     :rawAddress.sync="rawAddress"
      //-     @submitUserAddress="submitUserAddress"
      //-   )
      py-form-item(prop='')
        landing-input(
          v-model='formLabelAlign.venueName',
          :label='"Venue name"'
        )

      .app_checkbox
        .checkbox_label Are you interested in:
        el-checkbox-group(v-model='formLabelAlign.interested')
          el-checkbox(label='In table dining')
          el-checkbox(label='Pickup')
          el-checkbox(label='Preorder')
          el-checkbox(label='Delivery')

        .aov_radio_box
          .checkbox_label Preferred contact method:
          el-radio-group(v-model='formLabelAlign.contactMethod' fill="#10CFC9")
            el-radio(:label='"Email"') Email
            el-radio(:label='"Phone"') Phone
      el-button.bot_sty(
        @click='submitFrom($route.name === "aov" ? "aov" : "delivery")'
      ) Find out more
      .arrow.bounce(
        :style='{ opacity: bounceOpacity, visibility: visible }',
        @click='nextPage'
      )
        icon(size='28', color='#fff') arrow_downward

  .app_public_profitability.aov_public_profitability
    .app_public_title Look good, sell more, grow fast
    .app_public_label
    .app_public_describe Unlock the revenue potential of your menu! MondoMenu’s innovative features encourage customers to spend more while also enhancing the ordering experience.
    .app_public_content
      .content_box(v-for='(item, index) in profitabilityList', :key='index')
        img.content_img(:src='item.img')
        .content_title {{ item.title }}
        .content_label {{ item.text }}

  .app_public_simple
    .app_public_title Simple for customers…
    .app_public_label
    .app_public_describe {{ isAov ? "It’s time to ditch the paper menu! Without the need to download an app or wave down a waiter, your customers simply scan a QR code to order from your beautiful visual menu." : "Give your customers the ordering experience they deserve! No need to download an app or create an account." }}
    .app_public_content
      .content_box
        img.content_img(:src='isAov ? scanQRCode : accessMenu')
        .content_title STEP 1
        .content_label {{ isAov ? "Customers scan a QR code at their table to see the menu." : "Customers access your menu via your website, socials, SMS or email." }}

      .content_box
        img.content_img(:src='isAov ? accessMenu : PlaceOrder')
        .content_title STEP 2
        .content_label {{ isAov ? "Customers place their order and make a pasyment using their preferred payment method." : "They browse, order and pay via your digital menu." }}

      .content_box(:class='{ isVideo: isAov }')
        img.content_img(:src='isAov ? notification : WaitTime')
        .content_title.font_22 STEP 3
        .content_label {{ isAov ? "Customers have their meal brought to their table or receive an SMS alerting them to collect their order." : "Customers are notified of their pick-up/delivery time based on your average preparation time. " }}

    .app_public_video(v-if='isAov')
      iframe._video(
        width='100%',
        height='178',
        src='https://www.youtube.com/embed/FYJ1iFbwB8w',
        title='YouTube video player',
        frameborder='0',
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
        allowfullscreen
      )

  .app_public_videoBox
    .app_public_title Easy to setup and manage
    .app_public_label
    .app_public_describe You have full control over your menu, images and pricing from the MondoMenu portal.
    .app_public_video
      iframe(
        width='100%',
        height='178',
        src='https://www.youtube.com/embed/R9pa4gPaxNo',
        title='YouTube video player',
        frameborder='0',
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
        allowfullscreen
      )

  .app_public_why
    .app_public_title Why MondoMenu?
    .app_public_label
    .app_public_content
      .tip(v-for='item in whyList', :key='item')
        mu-icon.why_icon(value='done')
        .text_con {{ item }}

  .app_public_brands
    .app_public_title Venues already on board
    .app_public_label
    .app_public_describe Join a growing list of venues using MondoMenu to increase their average order value.
    infinite-slide-bar.swiper(duration='20s')
      .items
        img.content_img(src='./img/Glasshouse-bar.jpg')
        img.content_img(src='./img/Emirates.jpg')
        img.content_img(src='./img/Rovers.jpg')
        img.content_img(src='./img/Bathers.jpg')
        img.content_img(src='./img/Betel-Leaf.jpg')
        img.content_img(src='./img/Kiosk.jpg')
        img.content_img(src='./img/The-Prince.jpg')
        img.content_img(src='./img/Fouth.jpg')
        img.content_img(src='./img/Arabesque.jpg')

  van-popup(:value='openShow', :close-on-click-overlay='false', round)
    .app_container
      img.popup_img(src='./img/Tick-Icon.png')
      .title {{ t('thanks_for_registering', 'Thanks for registering your interest!') }}
      .title.test {{ t('we_will_be_in_touch', 'We will be in touch with you shortly.') }}
      el-button.popup_button(@click='openShow = false') {{ t('ok', 'OK') }}

  .aov_bottom_box
    .bottom_label Follow us on:
    img(src='./img/instagram.png', @click='toRouter("instagram")')
    mu-icon.child_icon(
      value='facebook',
      size='32',
      color='#10CFC9',
      @click='toRouter("facebook")'
    )
</template>

<script>
import mixin from './mixin'
import mondoAovImg from './img/Banner-image-AOV-Mobile.jpg'
import mondoDeliveryImg from './img/Banner-image-Delivery-Mobile.jpg'
import InfiniteSlideBar from 'vue-infinite-slide-bar'

export default {
  name: 'mobileAov',
  mixins: [mixin],

  components: {
    InfiniteSlideBar,
  },

  computed: {
    mondoHeaderImg() {
      return this.$route.name === 'aov' ? mondoAovImg : mondoDeliveryImg
    },
  },
}
</script>

<style lang="sass" scoped>
.s_app_box
  width: 100%

  .app_header
    position: relative
    display: flex
    width: 100%
    height: 0
    padding-bottom: 109vw

    .app_img
      width: 100%
      position: absolute

    .log_box
      position: absolute
      top: 20PX
      left: 0
      width: 100%
      text-align: center

    .app_log
      width: 231PX
      height: 45PX

  .app_from_box
    padding: 20PX 30PX 17PX
    background: #F8F9FA

    .form
      ::v-deep
        .py_form_item_box
          padding-bottom: 20PX

    .from_text
      font-size: 40PX
      text-align: center

    .app_from_title
      font-size: 30PX
      font-weight: bold
      line-height: 38PX
      color: #334455

    .app_from_text
      display: flex

      margin: 20PX 0

      .checked_icons
        display: flex
        flex-direction: column
        margin-right: 12PX

        ::v-deep .material-icons
          margin-bottom: 12PX
          font-size: 18PX
          color: #2AD2C9

          &:last-child
            margin-bottom: 0

      .checked_text
        .line
          margin-bottom: 16PX
          font-size: 14PX
          font-family: Roboto
          line-height: 14PX
          color: #334455
          opacity: 0.75

          &:last-child
            margin-bottom: 0

    .bot_sty
      width: 100%
      height: 54PX
      margin-bottom: 16PX
      padding: 0
      font-size: 20PX
      font-weight: bold
      line-height: 20PX
      color: #FFFFFF
      text-transform: uppercase
      background: #10CFC9
      border-radius: 4PX
      border: none

  .app_public_brands,
  .app_public_simple,
  .app_public_profitability,
  .app_public_videoBox,
  .app_public_why
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    padding: 0 30PX

    .app_public_describe
      width: 315PX
      margin-bottom: 30PX
      font-size: 14PX
      font-family: Roboto
      line-height: 20PX
      color: #334455
      opacity: 0.75
      text-align: center

    .app_public_label
      width: 126PX
      height: 4PX
      background: #10CFC9
      margin-bottom: 15PX

    .app_public_title
      width: 315PX
      margin: 30PX 0PX 15PX
      font-size: 25PX
      font-weight: bold
      line-height: 25PX
      color: #334455
      text-align: center

      &.brands_title
        width: 150PX

    .app_public_content
      .content_box
        display: flex
        flex-direction: column
        align-items: center
        width: 315PX
        margin-bottom: 30PX
        opacity: 0
        transform: translateY(20PX)
        transition: all 1s

        &.animation
          opacity: 1
          transform: translateY(0)

        .content_img
          width: 73PX
          margin-bottom: 20PX

        .content_label
          font-size: 14PX
          font-weight: 400
          line-height: 20PX
          color: #334455
          opacity: 0.75
          text-align: center

  .app_public_why
    padding-bottom: 50PX
    background: #F8F9FA

    .app_public_title
      text-align: center

    .app_public_content
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      margin-top: 15PX

      .tip
        display: flex
        justify-content: flex-start
        width: 100%
        margin-bottom: 13PX

        &:last-child
          margin-bottom: 0

        .why_icon
          margin-right: 15PX
          font-size: 24PX
          color: #22CFC9

        .text_con
          font-size: 14PX
          font-family: Roboto
          line-height: 20PX
          color: #364550
          opacity: 0.75

  .app_public_videoBox
    padding-bottom: 30PX

    .app_public_title
      margin-bottom: 15PX

  .app_public_simple
    background: #F8F9FA

    .app_public_label
      margin-bottom: 15PX

    .app_public_title
      text-align: center

    .app_public_video
      width: 100%
      margin-top: 20PX
      margin-bottom: 30PX

    .app_public_content
      .content_title
        margin-bottom: 6PX
        font-size: 22PX
        font-weight: bold
        line-height: 22PX
        color: #10CFC9

        &.font_22
          font-size: 22PX

      .content_label
        width: 320PX

      .content_box
        .content_img
          width: 270PX
          margin-bottom: 12PX
          vertical-align: middle

  .app_public_brands
    padding: 0PX 0 36PX
    background: #ffffff

    .swiper
      width: calc( 100vw - 20PX )

      .items
        display: flex

        .content_img
          width: 115PX
          margin-right: 10PX
          vertical-align: middle
          height: 100%

    .app_public_title
      text-align: center

    .app_public_content
      width: 100%
      display: flex
      flex-wrap: wrap
      justify-content: center

      .content_box
        width: 50%
        margin-bottom: 0PX

        .content_img
          width: 100%
          height: 100%
          margin-bottom: 0PX

  .app_bottom_box
    display: flex
    align-items: center
    height: 70PX
    background: #F8F9FA

    .bottom_label
      width: 100%
      text-align: right
      font-size: 16PX
      font-weight: bold
      line-height: 40PX
      color: #334455
      opacity: 0.35

  .app_public_profitability
    background: #ffffff

    .content_title
      margin-bottom: 15PX
      font-size: 25PX
      font-family: Raleway
      font-weight: bold
      line-height: 25PX
      color: #10CFC9

    .app_public_title
      width: 100%
      padding: 0 30PX
      text-align: center

  .aov_bottom_box
    display: flex
    align-items: center
    justify-content: center
    height: 70PX
    background: #F8F9FA

    .bottom_label
      margin-right: 13PX
      font-size: 16PX
      font-weight: bold
      line-height: 40PX
      color: #334455
      opacity: 0.35
      text-transform: uppercase

    .child_icon
      margin-left: 13PX

    .icon_sty
      width: 32PX
      height: 44PX
      color: #10CFC9

  .app_checkbox
    .checkbox_label
      margin-bottom: 12PX
      font-size: 14PX
      font-weight: bold
      line-height: 14PX
      color: #334455

.arrow
  position: fixed
  z-index: 10
  bottom: 0
  left: 50%
  display: flex
  justify-content: center
  align-items: center
  width: 55PX
  height: 55PX
  margin-top: -100PX
  margin-left: -27PX
  border-radius: 50%
  text-decoration: none
  background: #1FC4BC
  cursor: pointer

.fa-2x
  font-size: 32PX
  color: #1FC4BC

.bounce
  -moz-animation: bounce 4s infinite
  -webkit-animation: bounce 4s infinite
  animation: bounce 4s infinite

@keyframes bounce
  0%, 20%, 50%, 80%, 100%
    transform: translateY(0)

  40%
    transform: translateY(-30PX)

  60%
    transform: translateY(-15PX)

// 表单验证，不通过的样式
::v-deep
  .el-checkbox-group
    display: flex
    flex-wrap: wrap
    justify-content: space-between

  .error_form
    .mu-input-label
      color: #B00020 !important

    .float
      color: rgba(51, 68, 85, 0.5) !important

    .i-form-item-message
      bottom: 4PX
      font-size: 12PX !important
      color: #B00020

    .mu-text-field
      border: 2PX solid #B00020
</style>

<style lang="sass" scoped>
// 处理 element-ui 中 from 样式
::v-deep
  .el-form-item__content
    margin-left: 0PX !important

  .el-input
    width: 100% !important

  .el-form-item__label
    padding: 0PX
    font-size: 16PX
    font-weight: bold
    line-height: 17PX
    color: #334455

  .el-checkbox__input.is-checked+.el-checkbox__label
    color: #10CFC9 !important

  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner
    background-color: #10CFC9
    border-color: #10CFC9

  .el-checkbox__label
    width: 100PX
    color: #334455
    font-weight: 400

  .el-checkbox__inner
    height: 24PX
    width: 24PX

    &::after
      height: 10PX
      left: 8PX
      top: 3PX
      width: 5PX
      border: 2PX solid #FFF
      border-left: 0
      border-top: 0

::v-deep
  .is-checked
    border: none
    box-shadow: none

    .el-radio__inner
      border-color: #10CFC9 !important
      background: #fff !important

  .el-radio__inner
    width: 24PX
    height: 24PX
    border: 1PX solid rgba(54,69, 80,0.3)
    background: #fff

    &::after
      width: 12PX
      height: 12PX
      background: #10CFC9

  .el-radio__label
    font-size: 16PX
    line-height: 16PX
    font-weight: 400
    padding-left: 6PX
    color: black !important

  .el-radio
    display: flex
    align-items: center
    margin-right: 20PX
    font-size: 0

  .el-radio-group
    display: flex
    margin-bottom: 15PX
</style>

<style lang="sass" scoped>
::v-deep
  .van-popup--center
    border-radius: 15PX
    top: 184PX
    left: 50%
    margin-left: -141PX
    transform: translate3d(0, 0, 0)

  .el-checkbox
    margin-right: 20PX
    font-size: 16PX
    line-height: 16PX

  .el-checkbox__label
    font-size: 16PX
    padding-left: 6PX
    line-height: 16PX
    color: #334455

  .el-checkbox__inner
    height: 24PX !important
    width: 24PX !important
    border-radius: 3PX
    border: 1PX solid #DCDFE6

    &::after
      height: 10PX
      left: 8PX
      top: 3PX
      width: 5PX
      border: 2PX solid #FFF
      border-left: 0
      border-top: 0

  .el-checkbox__input.is-checked+.el-checkbox__label
    color: #10CFC9 !important

  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner
    background-color: #10CFC9 !important
    border-color: #10CFC9 !important

.el-checkbox
  margin-bottom: 13PX
  margin-right: 0

.app_container
  display: flex
  flex-direction: column
  align-items: center
  padding: 25PX
  width: 283PX
  height: 276PX

  .title
    margin-bottom: 8PX
    font-size: 18PX
    color: #334455
    font-weight: bold
    line-height: 22PX
    text-align: center

  .test
    margin-bottom: 18PX
    font-size: 14PX
    font-weight: 400

  .popup_img
    margin-bottom: 19PX
    width: 67PX

  .popup_button
    width: 232PX
    height: 54PX
    font-size: 14PX
    color: #fff
    background: #1FC4BC
</style>
